import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Col } from 'react-bootstrap'
import DatePicker from '../../../../LaridaeApp/datepicker/container/DatePicker'
import { actualizarDatosParaMuiTable } from '../actions/TablaConsultaCodigoDeCuposActions'
import TablaConsultaCodigoDeCuposView from '../components/TablaConsultaCodigoDeCuposView'
import ConsultaCodigoDeCupos from './ConsultaCodigoDeCupos'

const TablaConsultaCodigoDeCupos = (props) => {
  const [rolEntregador, setRolEntregador] = useState()
  const [rolExterno, setRolExterno] = useState(false)
  const [show, setShow] = useState(false)

  const {
    filtroInicial = null,
    cerealFiltro = null,
    codigosDeCupo,
    arriboFiltro = null,
    fechaFiltro = null,
    fechaDesde = null,
    roles,
    actualizarDatosParaMuiTable,
    showTitle = true,
    totalizador = false
  } = props

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR' || roles === 'CORREDOR')
    setRolExterno(rol.length > 0)

    const entregador = roles.filter(roles => roles === 'VENDEDOR')
    setRolEntregador(entregador[0] === 'VENDEDOR')

    if (filtroInicial && fechaFiltro) {
      const fechaD = fechaDesde || fechaFiltro
      const fechaH = fechaFiltro
      actualizarDatosParaMuiTable(fechaD, fechaH, roles, cerealFiltro, arriboFiltro, filtroInicial)
    }
  }, [
    roles,
    filtroInicial,
    fechaFiltro,
    fechaDesde,
    setRolEntregador,
    setRolExterno,
    actualizarDatosParaMuiTable,
    arriboFiltro,
    cerealFiltro
  ])

  const actualizarFechas = (fechaD, fechaH) => {
    const { roles } = props
    setShow(true)
    const fechaDesde = moment(new Date(fechaD)).format('YYYY-MM-DD')
    const fechaHasta = fechaH ? moment(new Date(fechaH)).format('YYYY-MM-DD') : fechaDesde
    props.actualizarDatosParaMuiTable(fechaDesde, fechaHasta, roles)
  }

  return (
    <>
      { showTitle && <h3>Códigos de cupos</h3> }

      {filtroInicial
        ? <TablaConsultaCodigoDeCuposView codigosDeCupo={totalizador ? codigosDeCupo : null} />
        : <>
          {!rolEntregador
            ? <>
              <div className='codigo-de-cupos-header'>
                <Col md={4}>
                  <DatePicker
                    selectRange={rolExterno}
                    fechaDesde={fechaDesde || null}
                    locale='es'
                    onDateChange={actualizarFechas}
                    titulo='Seleccione las fechas'
                    value='fechas'
                  />
                </Col>
                <ConsultaCodigoDeCupos />
              </div>
              {show
                ? <TablaConsultaCodigoDeCuposView codigosDeCupo={totalizador ? codigosDeCupo : null} />
                : <p
                  style={{ textAlign: 'left', margin: '0 12px', float: 'left' }}
                  className='box-info'
                >
                  Seleccione una fecha para visualizar el listado de códigos de cupos
                </p>
              }
            </>
            : <div style={{ display: 'flex', justifyContent: 'center', marginTop: '38px' }}>
              <ConsultaCodigoDeCupos />
            </div>
          }
        </>
      }

    </>
  )
}

const mapStateToProps = (state) => {
  return {
    codigosDeCupo: state.cupos.codigosDeCupo,
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

export default connect(mapStateToProps, mapActionsToProps)(TablaConsultaCodigoDeCupos)
